import { render, staticRenderFns } from "./ActiveRetailers.vue?vue&type=template&id=ad3eb438"
import script from "./ActiveRetailers.vue?vue&type=script&lang=js"
export * from "./ActiveRetailers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports